import { render, staticRenderFns } from "./aboutIntro.vue?vue&type=template&id=592650d1&scoped=true"
import script from "./aboutIntro.vue?vue&type=script&lang=js"
export * from "./aboutIntro.vue?vue&type=script&lang=js"
import style0 from "./aboutIntro.vue?vue&type=style&index=0&id=592650d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592650d1",
  null
  
)

export default component.exports